import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { mainnet as viemMainnet } from 'viem/chains'

import type { AppChain } from './chain.types'

export const mainnet = viemDefineChain({ ...viemMainnet, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Ethereum Mainnet',
    shortName: 'Ethereum',
    safeShortName: 'eth',
    morphoChainSlug: 'ethereum',
    defiLlamaSlug: 'ethereum',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://etherscan.io', name: 'Etherscan' },
    resetAllowanceBeforeApproveTokens: [
      '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT
      '0xD533a949740bb3306d119CC777fa900bA034cd52' // CRV
    ],
    simplePermitTokens: [
      '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0', // wstETH
      '0x83F20F44975D03b1b09e64809B757c47f942BEeA', // sDAI
      '0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38', // osETH
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // USDC
      '0x6B175474E89094C44Da98b954EedeAC495271d0F' // DAI
    ],
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x870aC11D48B15DB9a138Cf899d20F13F79Ba00BC',
          startBlock: 18883124n
        },
        MorphoBlue: {
          address: '0xBBBBBbbBBb9cC5e90e3b3Af64bdAF62C37EEFFCb',
          startBlock: 18883124n
        },
        MetaMorphoV10Factory: {
          address: '0xA9c3D3a366466Fa809d1Ae982Fb2c46E5fC41101',
          startBlock: 18925584n
        },
        MetaMorphoV11Factory: {
          address: '0x1897A8997241C1cD4bD0698647e4EB7213535c24',
          startBlock: 21439510n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xA1D94F746dEfa1928926b84fB2596c06926C0405',
          startBlock: 23375073n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0xb049465969ac6355127cDf9E88deE63d25204d5D',
          startBlock: 23375073n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x32BB1c0D48D8b1B3363e86eeB9A0300BAd61ccc1',
          startBlock: 23981459n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xD1B8E2dee25c2b89DCD2f98448a7ce87d6F63394',
          startBlock: 23375073n
        },
        RegistryList: {
          address: '0x3696c5eAe4a7Ffd04Ea163564571E9CD8Ed9364e',
          startBlock: 23375119n
        },
        BluePublicAllocator: {
          address: '0x00b8e1509398ED692C3F326CbAf1694F9A881e27',
          startBlock: 25770408n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
